'use strict';

import React from 'react';

import Confirmation from "../../components/Confirmation/Confirmation";
import Title from "../../components/Title/Title";
import Wizard from "../../components/Wizard/Wizard";
import { OnSchedUtils } from "../../utils";
import { OnSchedRest } from "../../OnSchedRest";


const ServiceSetup = element => {
  const [submitted, submit] = React.useState(false);
  const [state, setState] = React.useState({});

  let action = element.params.id ? 'Put' : 'Post';
  
  const onSubmit = values => {
    OnSchedUtils.ReformatAPIPayload(element).ServiceSetup({values, state})
    .then(response => {
        let data = response;
        
        data.locationId = element.params.locationId;

        OnSchedRest[action](element.onsched.setupApiBaseUrl + '/services', data, servicesResponse => {
          let i = 0;
          let returnData = servicesResponse;
          returnData.blocks = [];
          
          if (data.blocks) {
            const addBlocks = () => {
              const createServiceBlocks = (block) => new Promise((resolve, reject) => {
                const blockPayload = {
                  "locationId": data.locationId,
                  "startDate": block.startDate,
                  "endDate": block.endDate,
                  "startTime": block.startTime,
                  "endTime": block.endTime,
                  "reason": "Time block",
                  "repeats": false,
                  "repeat": {
                    "frequency": "D",
                    "interval": 1,
                    "weekdays": "",
                    "monthDay": block.startDate.slice(8,10),
                    "monthType": "D"
                  }
                }
                
                OnSchedRest.Post(element.onsched.setupApiBaseUrl + '/services/' + servicesResponse.id + '/block', blockPayload, blocksResponse => {
                  setTimeout(() => {
                    resolve(blocksResponse)
                  }, 500);
                })
              })
  
              createServiceBlocks(data.blocks[i])
                .then(serviceBlocksResponse => {
                  returnData.blocks.push(serviceBlocksResponse);
                  
                  while (i < data.blocks.length) {
                    i += 1;
  
                    if (data.blocks[i]) {
                      addBlocks();  
                    }
                    else {
                      OnSchedUtils.Toast(element, OnSchedUtils.successToastMsgs.service[action]);
                      OnSchedUtils.CustomEvents(element.id, 'serviceSetupComplete', returnData);
  
                      break;
                    };
                  }
                })
            };

            addBlocks();
          }
          else {
            OnSchedUtils.CheckErrors({ element, data: returnData })
              .then(validatedReturnData => {
                OnSchedUtils.Toast(element, OnSchedUtils.successToastMsgs.service[action])
                OnSchedUtils.CustomEvents(element.id, 'serviceSetupComplete', validatedReturnData);
              });
          }
        })
      })
  }

  if (!submitted) {
    return (
      <>
        <Title element={element} title={OnSchedUtils.Internationalize(element, 'setup_serviceSetup_title')}/>
        <Wizard onSubmit={onSubmit} element={element} onschedState={{state, setState}} form="ServiceForm" />
      </>
    )
  }
  else {
    return (
      <Confirmation msg={OnSchedUtils.Internationalize(element, 'setup_serviceSetup_confirmation')} />
    )
  }
}

export default ServiceSetup;
